import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("sine_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("sine_token");
    if (!t) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("sine_token");
        setToken(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("sine_token", r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("sine_token", r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("sine_token");
    setToken(null);
    setUser(null);
  };

  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
  };

  const isAdmin = user && ["super_admin", "editor_in_chief", "editor", "province_admin", "province_editor", "ad_manager", "moderator", "support", "author"].includes(user.role);
  const isSuperAdmin = user?.role === "super_admin";

  return (
    <AuthCtx.Provider value={{ user, token, login, register, logout, refreshUser, isAdmin, isSuperAdmin, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
